import { Text, VStack } from '@chakra-ui/react';
import { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { BreadcrumbCurrentLink, BreadcrumbRoot } from '@/components';
import { useBreadcrumbs } from '@/hooks';

function Breadcrumb() {
  const { breadcrumbs } = useBreadcrumbs();
  const currentPageName = breadcrumbs[breadcrumbs.length - 1]?.subname ? breadcrumbs[breadcrumbs.length - 1]?.subname : breadcrumbs[breadcrumbs.length - 1]?.name;

  return (
    <VStack alignItems="flex-start" justifyContent="center" gap={0}>
      <BreadcrumbRoot
        separator={
          <Text color={'#2D3748'} fontSize={'14px'} fontWeight={'bold'}>
            /
          </Text>
        }
      >
        {breadcrumbs.map((breadcrumb, index) => {
          if (!breadcrumb.path) {
            return (
              <>
                <BreadcrumbCurrentLink key={index} style={{ color: '#2D3748' }}>{breadcrumb.name}</BreadcrumbCurrentLink>
              </>
            );
          }
          return (
            <BreadcrumbCurrentLink key={index}>
              <NavLink to={breadcrumb.path} style={{ color: "#A0AEC0" }}>{breadcrumb.name}</NavLink>
            </BreadcrumbCurrentLink>
          );
        })}
      </BreadcrumbRoot>
      <Text textAlign="left" fontSize="14px" fontWeight="700" color="#6A6A6A">
        {currentPageName}
      </Text>
    </VStack>
  );
}

export default memo(Breadcrumb);
